import React from 'react';
import { Link } from 'react-router-dom';
import './ISO27001.css';

const ISO27001 = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="page-main">
          <section className="page-section">
            <div className="page-breadcrumb">System Certification</div>
            <h1 className="page-title">ISO 27001 Information Security Management System</h1>
            <h2 className="page-subtitle">NQC Security in Information Security: ISO 27001</h2>
            <div className="page-text-content">
              <p>
                NQC (Nova Quality Certification Agency) is creating detailed content on the ISO 27001 
                Information Security Management System to effectively promote the professional services 
                we offer in certification and accreditation.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">What is ISO 27001 Information Security Management System?</h2>
            <div className="page-text-content">
              <p>
                ISO 27001 is an international standard for defining and implementing information security 
                management systems. This standard focuses on managing information assets, reducing risks, 
                and continuous improvement. It covers the three fundamental principles of information 
                security: confidentiality, integrity, and availability.
              </p>
              <p>
                ISO 27001 requires organizations to establish, implement, monitor, and review policies 
                and processes for information security management. Key principles include risk assessment, 
                internal training, and continual improvement, guiding organizations in enhancing security 
                against threats and ensuring legal compliance.
              </p>
              <p>
                ISO 27001 certification verifies an organization's implementation of an information 
                security management system, demonstrating commitment to security and compliance for 
                customers, business partners, and stakeholders.
              </p>
              <p>
                The standard is suitable for organizations of all sizes and sectors, providing a robust 
                framework for protecting information assets and creating a trustworthy business environment.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">NQC's ISO 27001 Services</h2>
            <div className="page-text-content">
              <p>
                At NQC (Nova Quality Certification Agency), we stand out with the services we provide 
                related to the ISO 27001 Information Security Management System.
              </p>
            </div>
            <div className="services-list">
              <div className="service-item">
                <h3 className="service-title">1. Establishing a Strong Information Security Culture</h3>
                <p className="service-description">
                  We guide organizations in establishing a strong information security culture in line 
                  with ISO 27001 standards. This culture ensures that employees gain awareness of 
                  information security and stay updated continuously.
                </p>
              </div>
              <div className="service-item">
                <h3 className="service-title">2. Risk Management and Assessment</h3>
                <p className="service-description">
                  During the transition to ISO 27001, we assist organizations in identifying and 
                  effectively managing information security risks they encounter. By adopting a risk-based 
                  approach, we help our clients protect sensitive information effectively.
                </p>
              </div>
              <div className="service-item">
                <h3 className="service-title">3. Policy and Process Development</h3>
                <p className="service-description">
                  We support organizations in creating policies and processes compliant with ISO 27001 
                  standards, enabling them to implement an information security management system 
                  effectively. This is a crucial step in ensuring legal compliance and establishing a 
                  reliable information security framework.
                </p>
              </div>
              <div className="service-item">
                <h3 className="service-title">4. Training and Awareness Programs</h3>
                <p className="service-description">
                  Employee training and awareness are fundamental to creating a secure work environment. 
                  Therefore, we provide tailored training and awareness programs to support organizations 
                  in this aspect.
                </p>
              </div>
              <div className="service-item">
                <h3 className="service-title">5. Internal Auditing and Review</h3>
                <p className="service-description">
                  We conduct regular internal audits and management reviews to ensure the sustainability 
                  of ISO 27001 compliance. These processes help organizations confirm that they are 
                  effectively implementing the information security management system.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Conclusion</h2>
            <div className="page-text-content">
              <p>
                NQC (Nova Quality Certification Agency) provides organizations with a secure information 
                management solution through its customer-focused approach, industry experience, and 
                expertise in the ISO 27001 Information Security Management System. By helping our 
                clients protect their information assets effectively, we maintain our leadership in 
                the industry.
              </p>
            </div>
          </section>
        </div>

        <aside className="page-sidebar">
          <div className="sidebar-section">
            <h2 className="sidebar-title">Our Services</h2>
            <ul className="sidebar-links">
              <li><Link to="/system-certification">System Certification</Link></li>
              <li><Link to="/product-certification">Product Certification</Link></li>
              <li><Link to="/quality-certification">Quality Certification</Link></li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default ISO27001;

